import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ChatList } from '../components/chat/ChatList';
import { ChatWindow } from '../components/chat/ChatWindow';
import { useSearchParams } from 'react-router-dom';

const Page = styled.div`
  background: var(--background);
  padding: 1.5rem;
  min-height: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  height: calc(100vh - 64px - 3rem); /* header + page padding */
  background: var(--surface);
  border: 1px solid var(--outline);
  border-radius: 14px;
  box-shadow: 0 12px 24px rgba(17, 24, 39, 0.06);
  overflow: hidden;
`;

export default function KidsChurchMessagesPage() {
  const [selected, setSelected] = useState<string | null>(null);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const recipient = searchParams.get('recipient');
    if (recipient) {
      setSelected(recipient);
    }
  }, [searchParams]);

  return (
    <Page>
      <Wrapper>
        <ChatList
          selectedId={selected}
          onSelect={setSelected}
          includeUserIds={selected ? [selected] : []}
        />
        <ChatWindow otherUserId={selected} />
      </Wrapper>
    </Page>
  );
}
